import React, {useMemo, useState} from 'react';
import {useIntl} from 'react-intl';
import {useTable} from 'react-table';
import * as actions from '../../_redux/partnersActions';
import * as columnFormatters from '../../../_common/column-formatters';
import {usePartnersUIContext} from '../PartnersUIContext';
import useInfiniteScrollControl
  from '../../../_common/components/_custom-hooks/useInfiniteScrollControl';
import CommonGrid from "../../../_common/components/CommonGrid/CommonGrid";

export function PartnersTable() {
  const intl = useIntl();

  const [tableRows, setTableRows] = useState([]);

  const columns = useMemo(() => [
    {
      accessor: 'fullName',
      Header: intl.formatMessage({
        id: 'partners-column-fullName', defaultMessage: 'Full name'
      })
    },
    {
      accessor: 'phone',
      Header: intl.formatMessage({
        id: 'partners-column-phone', defaultMessage: 'Phone'
      })
    },
    {
      accessor: 'email',
      Header: intl.formatMessage({
        id: 'partners-column-email', defaultMessage: 'Email'
      })
    },
    {
      accessor: 'createdAt',
      Header: intl.formatMessage({
        id: 'partners-column-createdAt', defaultMessage: 'Registered date'
      })
    },
    {
      accessor: 'lastCompletedStep',
      Header: intl.formatMessage({
        id: 'partners-column-lastCompletedStep',
        defaultMessage: 'Last completed step'
      })
    },
    {
      accessor: 'agentId',
      Header: intl.formatMessage({
        id: 'partners-column-agentId', defaultMessage: 'Agent Id'
      })
    },
    {
      accessor: 'partnerName',
      Header: intl.formatMessage({
        id: 'partners-column-partnerName', defaultMessage: 'Partner name'
      })
    },
  ], []);
  const data = useMemo(() => [
    ...tableRows.map((item) => {
      return {
        fullName: columnFormatters.FullNameColumnFormatter(item.profile),
        phone: columnFormatters.BoldColumnFormatter(item.profile.phone),
        email: columnFormatters.BoldColumnFormatter(item.email),
        createdAt: columnFormatters.DateColumnFormatter(item.createdAt),
        lastCompletedStep: columnFormatters.LastCompletedStepColumnFormatter(item.lastCompletedStep),
        agentId: columnFormatters.BoldColumnFormatter(item.agentId),
        partnerName: columnFormatters.BoldColumnFormatter(item.partnerName),
      };
    })
  ], [tableRows]);

  const infiniteScrollProps = useInfiniteScrollControl({
    currentStateStoreId: 'partners',
    UIContext: usePartnersUIContext(),
    getNewEntities: actions.getPartners,
    getNextEntities: actions.getNextPartners,
    onEntitiesChange: entities => {
      setTableRows(entities);
    },
    dataLength: tableRows.length,
    scrollableTarget: 'scrollContainer',
    scrollThreshold: 0.9,
    loader: (
      <div className={'spinner-container'}>
        <span className={'spinner spinner-md spinner-primary'}/>
      </div>
    ),
    style: {
      overflow: 'inherit'
    },
  });

  return (
    <CommonGrid
      infiniteScrollProps={infiniteScrollProps}
      tableProps={useTable({columns, data})}
    />
  );
}
